<div *ngIf="mode === 'inline'" class="mc-rich-text-block-inline" [innerHTML]="content"></div>
<div *ngIf="mode === 'plain'" class="mc-rich-text-block-plain" [innerHTML]="content"></div>
<div *ngIf="mode === 'rich'" class="mc-rich-text" [innerHTML]="content"></div>
<div *ngIf="mode === 'truncate'" class="mc-rich-text-block-truncate" [innerHTML]="content" [matTooltip]="tooltip"></div>
